export default __webpack_public_path__ + "static/media/vincennes4.4649a538.jpg";